import React, { Component } from 'react';
import PreRender from './../../common/PreRender';
import MainContent from './MainContent';

class MoneyFlow extends Component {
  render() {
    return (
      <PreRender {...this.props}>
        <MainContent {...this.props} />
      </PreRender>
    );
  }
}

export default MoneyFlow;
